enum Actions {
	SET_BUCKET_RANGE = '[IndustryInsights] SET_BUCKET_RANGE',
	SET_DESCRIPTION = '[IndustryInsights] SET_DESCRIPTION',
	SET_IMPORT_DATE = '[IndustryInsights] SET_IMPORT_DATE',
	SET_HAS_TIME_SERIES_DATA = '[IndustryInsights] SET_HAS_TIME_SERIES_DATA',
	SET_HAS_KEY_FIGURES_DATA = '[IndustryInsights] SET_HAS_KEY_FIGURES_DATA',
	SET_HAS_MARKET_SHARE_DATA = '[IndustryInsights] SET_HAS_MARKET_SHARE_DATA',
	SET_COMPETITOR_LOADING = '[IndustryInsights] SET_COMPETITOR_LOADING',
	SET_KEY_FIGURES_LOADING = '[IndustryInsights] SET_KEY_FIGURES_LOADING',
	SET_MARKET_SHARE_LOADING = '[IndustryInsights] SET_MARKET_SHARE_LOADING'
}

export default Actions;
